import React from 'react';
import { Shield, Target, Zap, Users } from 'lucide-react';
import { BenefitCard } from '../../components/BenefitCard';
export function TaekwondoNearMeBenefits() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-3385">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3386">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3387">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-3388">
            Why Families Choose Storm
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-3389">
          <BenefitCard icon={Shield} title="Confidence" description="Build self-esteem through structured progression and achievement." data-id="element-3390" />
          <BenefitCard icon={Target} title="Focus" description="Develop mental clarity and concentration that carries off the mat." data-id="element-3391" />
          <BenefitCard icon={Zap} title="Fitness" description="Improve strength, flexibility, and cardiovascular health." data-id="element-3392" />
          <BenefitCard icon={Users} title="Community" description="Join a supportive, family-friendly environment." data-id="element-3393" />
        </div>
      </div>
    </section>;
}